import(/* webpackMode: "eager" */ "/app/app/learning/page.tsx");
